import * as React from 'react';
const SvgArrowShortBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 8 14" fill="none" {...props}>
        <path
            d="M2.418 7.002l4.79 4.793a1 1 0 01-1.415 1.414l-5.496-5.5a1 1 0 010-1.414l5.496-5.5A1 1 0 017.208 2.21l-4.79 4.793z"
            fill="currentColor"
        />
    </svg>
);
export default SvgArrowShortBold;
